import React from 'react'
import Tr from 'translations/Translations';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconPreviewButton(
    {
        tooltip = Tr('preview'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={VisibilityIcon}
        {...props}
    />
}

WorkableIconPreviewButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconPreviewButton;